// Dates in one place (#444). CRM stores a date as YYYY-MM-DD; people see it
// the Australian way, dd/mm/yyyy, on every screen and in every document.

const AU_DATE = new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric' });
const AU_DATE_TIME = new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit' });

/** YYYY-MM-DD at the start of a stored value ("2026-10-20" or "2026-10-20T00:00:00Z"). */
const STORED_DAY = /^(\d{4})-(\d{2})-(\d{2})/;

/** Today on this device as YYYY-MM-DD — what CRM stores (pricing date, reviewed-on) and what file names carry. */
export const isoToday = (): string => new Date().toLocaleDateString('en-CA');

/** Today on this device as people see it: 21/10/2026. */
export const auToday = (): string => AU_DATE.format(new Date());

/** A stored date shown as 20/10/2026; null when the value holds no date. */
export function formatDate(value: unknown): string | null {
  const day = STORED_DAY.exec(typeof value === 'string' ? value : '');
  return day ? `${day[3]}/${day[2]}/${day[1]}` : null;
}

/** A moment (an ISO timestamp) in this device's time: 21/10/2026, 3:45 pm. */
export const formatDateTime = (iso: string): string => AU_DATE_TIME.format(new Date(iso));
